var _circle, _ellipse, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatFantasy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "#ede8fc",
    stroke: "#c0a8f0",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 58,
    rx: 22,
    ry: 6,
    fill: "#5020a0",
    stroke: "#3a1080",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 58 L40 14 L54 58Z",
    fill: "#6a30c0",
    stroke: "#3a1080",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 58 Q40 52 54 58",
    stroke: "#f9d64f",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 26 L41 29 L44 29 L41.5 31 L42.5 34 L40 32 L37.5 34 L38.5 31 L36 29 L39 29Z",
    fill: "#f9d64f",
    stroke: "#c8a800",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40 L32.7 42.2 L35 42.2 L33.2 43.5 L33.9 45.7 L32 44.4 L30.1 45.7 L30.8 43.5 L29 42.2 L31.3 42.2Z",
    fill: "#f9d64f",
    stroke: "#c8a800",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36 L48.5 37.5 L50.2 37.5 L48.9 38.5 L49.3 40 L48 39.1 L46.7 40 L47.1 38.5 L45.8 37.5 L47.5 37.5Z",
    fill: "#f9d64f",
    stroke: "#c8a800",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 38,
    r: 2,
    fill: "#c080f0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 42,
    r: 1.5,
    fill: "#c080f0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 50 L22.7 48 L23.4 50 L21.4 49 L24 49Z",
    fill: "#f9d64f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58 30 L58.7 28 L59.4 30 L57.4 29 L60 29Z",
    fill: "#f9d64f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatFantasy);
export default __webpack_public_path__ + "static/media/cat-fantasy.0966e347636c485da7e098b9209ab988.svg";
export { ForwardRef as ReactComponent };